import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';
import {PrivateRoute} from "./components/PrivateRoute";
import {Role} from "./helpers/role";
import Dashboard from "./components/Dashboard";
import Business from "./components/Business";
import Transaction from "./components/Transaction";
import PaymentLink from "./components/PaymentLink";
import Balance from "./components/Balance";
import ApiDocumentation from "./components/documentation/ApiDocumentation";

const AppRoute = () => {

    return (
        <div className="layout-content">
            <PrivateRoute roles={[Role.ROLE_USER]} path={["/", "/home"]} exact component={Dashboard}/>
            <PrivateRoute roles={[Role.ROLE_USER]} path="/business" component={Business}/>
            <PrivateRoute roles={[Role.ROLE_USER]} path="/transactions" component={Transaction}/>
            <PrivateRoute roles={[Role.ROLE_MERCHANT]} path="/payments" component={PaymentLink}/>
            <PrivateRoute roles={[Role.ROLE_USER]} path="/balances" component={Balance}/>
            <PrivateRoute roles={[Role.ROLE_DEVELOPER]} path="/documentation" component={ApiDocumentation}/>
        </div>
    );

}

export default AppRoute;
